import api from './index';
// axios
import request from '@/utils/request';

// 获取充电桩列表
export function getChargingStation(params) {
  return request({
    url: api.ChargingStation,
    method: 'get',
    params
  });
}

// 获取收藏列表
export function getCollectList(params) {
  return request({
    url: api.GetCollectList,
    method: 'get',
    params
  });
}

// 添加收藏
export function addCollect(data) {
  return request({
    url: api.AddCollect,
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  });
}

// 删除收藏
export function delCollect(params) {
  return request({
    url: `${api.DelCollect}${params.id}/`,
    method: 'delete'
  });
}

// 获取充电桩对应电梯列表
export function getChargeElevator(params) {
  return request({
    url: api.GetChargeElevatorList,
    method: 'get',
    params
  });
}